<template>
  <div>
    <b-form class="b-layout" @submit.prevent="">
      <div>
        <label>{{$t('title')}}</label>
        <b-input class="input-pentagro" v-model="title"></b-input>
      </div>
      <div>
        <label>{{$t('desiredValue')}} {{ attrSelected ? `(${attrSelected})` : '' }}</label>
        <b-input class="input-pentagro" :disabled="attrSelected == ''" v-model="value" type="number"/>
      </div>

      <!-- BOTÕES -->
      <b-button-group class="m-2">
        <b-button 
          @click="select(0)" 
          :class="{'btn-success': buttonSelected.current }">
          {{$t('currents')}}
        </b-button>
        <b-button 
          @click="select(1)" 
          :class="{'btn-success': buttonSelected.operation }">
          {{$t('operations')}}
        </b-button>
      </b-button-group>
      <!-- /BOTÕES -->

      <!-- CORRENTE -->
      <div v-if="buttonSelected.current" class="pt-2">

        <label for="select-current">{{$t('selectACurrent')}}</label>
        <select 
          id="select-current" 
          class="form-control" 
          @change="changeCurrent()" 
          v-model="form.current"> 
            <option value="" selected>{{$t('chooseACurrent')}}</option>
            <option v-for="(current, index) in currents"
              :key="`node-current-${index}`" :value="current">
                {{current}}
            </option>
        </select>

        <div v-if="form.current" class="pt-2">
          <select 
            id="select-properties" 
            class="form-control" 
            @change="changeCurrentProperties()" 
            v-model="form.prop">
              <option value="" selected>{{$t('chooseAProperty')}}</option>
              <option v-for="(prop, index) in currentProperties"
                :key="`node-prop-${index}`" :value="prop">
                  {{ prop.name }}
              </option>
          </select> 
        </div>
      </div>

      <div v-if="false">
        <label for="select-component">{{$t('selectAComponent')}}</label>
      </div>
      <!--/CORRENTE -->

      <!-- OPERATIONS -->
      <div v-if="buttonSelected.operation" class="pt-2">
        <label for="select-operation">{{$t('operations')}}</label>
        <select class="form-control" id="select-operation" @change="changeOperation()" v-model="form.operation"> 
            <option value="null" selected>{{$t('chooseAOperation')}}</option>
            <option v-for="(operation, index) in operations"
              :key="index" :value="operation">
                {{operation}}
            </option>
        </select>                      
      </div>
      <!-- /OPERATIONS -->

      <!-- ATRIBUTOS -->
      <div 
        v-if="form.prop || form.operation" 
        class="pt-2 node-attr">
        <b-form-select 
          id="select-attr" 
          class="form-control input-pentagro" 
          v-model="attrSelected"> 
            <b-form-select-option value="null" selected>{{$t('chooseAAtribute')}}</b-form-select-option>
            <b-form-select-option v-for="([key, value], index) in attrsMap.entries()"
              :key="`node-attr-${index}`" :value="key">
                {{`${value.key}: ${formatNumber(value.value)}`}}
            </b-form-select-option>
        </b-form-select>
      </div>

      <!-- /ATRIBUTOS -->
    </b-form>
  </div>
</template>

<script>
import { SingletonEnginnering } from "../_service/singletonEngineering"
import { formatBR }     from "../../../flowchart/utils/numbers.js"   

export default {
  props: {
    node: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      formatNumber: formatBR,                     
      value: this.node.data[0].value.replace(",", "."),
      title: this.node.title,
      currents: SingletonEnginnering.currents,
      operations: SingletonEnginnering.operations,
      buttonSelected: {current: false, operation: false},
      currentProperties: "",
      attrsSelected: "",
      attrSelected: "",
      attrsMap: new Map(),
      form: {
        current: '',
        operation: '',
        prop: '',
        title: '',
        titleWidth: 0,
        titleHeight: 0,
        titleFontSize: 0,
        attr: ''
      },
    }
  },

  watch:{
    value(){
      this.node.attrs[0].value = formatBR(this.value);
    },
    title(){
      this.node.title = this.title;
    },
    attrSelected(value){
      if(value == "null" || !this.attrsMap.has(value)) return
      this.value = String(this.attrsMap.get(this.attrSelected).value).replace(",", ".")
      this.node.attrs = [this.attrsMap.get(this.attrSelected)];

      if(this.attrSelected == "vmC")
        this.setNodeDivisor()
    },
  },

  methods: {
    select(indice){
      Object.keys(this.buttonSelected).forEach((show, i) => { this.buttonSelected[show] = i == indice })
      this.form.current = ""
      this.form.operation = ""
      this.form.prop = ""
      this.form.attr = ""
    },

    changeCurrent(){
      let props = SingletonEnginnering.getCurrentProperties(this.form.current);
      this.currentProperties = props
      this.form.prop = ""
      this.form.attr = ""
      this.attrsSelected = null;
      this.attrSelected = "null"
      this.attrsMap = new Map();
      this.node.dataType = "Correntes"
    },

    changeCurrentProperties(){
      let attrs = SingletonEnginnering.getCurrentPropertiesAttributes(this.form.current, this.form.prop);
      this.attrsSelected = attrs;
      this.attrsMap = new Map()
      attrs.forEach(e => this.attrsMap.set(e.key, e))
    },

    changeOperation(){
      let attrs = SingletonEnginnering.getOperationsProperties(this.form.operation);
      this.attrsSelected = attrs
      let attrBackup = null;
      if (this.attrsMap.has(this.attrSelected)) {
        attrBackup = this.attrsMap.get(this.attrSelected);
        this.attrSelected = null;
      }
      this.attrsMap = new Map()
      attrs.forEach(e => this.attrsMap.set(e.key, e))
      this.node.dataType = "Operações"

      setTimeout(() => {
        if (attrBackup && this.attrsMap.has(attrBackup.key)) {
          this.attrSelected = attrBackup.key
        }
      }, 150)
      
    },

    updateNode() {

    },

    loadNode(){
      if(!this.node.dataType)
        return

      if(this.node.dataType == 'Operações'){
        this.buttonSelected.operation = true;
        this.form.operation = this.node.data[0].index
        this.changeOperation()
        this.attrsMap.set(this.node.data[0].key, this.node.data[0])
        this.attrSelected = this.node.data[0].key
      }else{
        this.buttonSelected.current = true;
        this.form.current = this.node.data[0].index
        this.changeCurrent()
        this.form.prop = {index: this.node.data[0].propIndex, name: this.node.data[0].propName}
        this.changeCurrentProperties()
        this.attrsMap.set(this.node.data[0].key, this.node.data[0])
        this.attrSelected = this.node.data[0].key
      }
    },

    setNodeDivisor(){
      this.node.isvmCTon = !JSON.parse(this.attrsMap.get("porcentagem").value)
    }
  },
  
  mounted(){ 
    this.loadNode(); 
  }
}
</script>

<style scoped>
form{
  padding: 10px;
  color: #0009;
}
</style>